
















































































import mixins from 'vue-typed-mixins'
import {
  LocationType,
  Location,
  LocationProject,
} from '@/interfaces/valuation/types/LocalityValuationStep'
import localityPicker, {
  AutocompleteObject,
} from '@/mixins/valuation/localityPicker'
import { ProjectCMService } from '@/services/location/projectCM'
import { IdValueObject, ValidatedResponse } from '@/interfaces/app/ValueObjects'
import { getNestedValue } from '@/util/helpers'
import { BuildingStatus } from '../../../interfaces/valuation/types/BuildingValuationStep'

export default mixins(localityPicker).extend({
  name: `${LocationType.Project}-picker`,
  created() {
    if (this.locationData) {
      this.cachedLocationData = JSON.parse(JSON.stringify(this.locationData))
    }
    this.region.loading = true
    this.projectLocationService
      .getRegions()
      .then(regions => {
        this.region.items = regions as IdValueObject[]
        const cachedId = getNestedValue(this.cachedLocationData, [
          'locationProjectRegionId',
        ])
        if (cachedId && this.region.items.find(i => i.id === cachedId)) {
          this.region.id = cachedId
        }
      })
      .finally(() => (this.region.loading = false))
  },
  data(): {
    region: AutocompleteObject
    district: AutocompleteObject
    project: AutocompleteObject
    building: AutocompleteObject
    cachedLocationData: LocationProject | undefined
    BuildingStatus: any
  } {
    return {
      region: {
        id: undefined,
        search: '',
        items: [],
        loading: false,
      },
      district: {
        id: undefined,
        search: '',
        items: [],
        loading: false,
      },
      project: {
        id: undefined,
        search: '',
        items: [],
        loading: false,
      },
      building: {
        id: undefined,
        search: '',
        items: [],
        loading: false,
      },
      cachedLocationData: undefined,
      BuildingStatus,
    }
  },
  computed: {
    locationData(): LocationProject | undefined {
      const stepData = this.$store.getters['valuationProcess/currentStepData']
      if (stepData.location) {
        return stepData.location as LocationProject
      }
    },
    projectLocationService(): ProjectCMService {
      return this.locationService as ProjectCMService
    },
    location(): ValidatedResponse<LocationProject> {
      if (
        !this.region.id ||
        !this.region.search ||
        !this.district.id ||
        !this.district.search ||
        !this.project.id ||
        !this.project.search
      ) {
        return { valid: false }
      }
      if (
        this.buildingStatus === BuildingStatus.Finished &&
        (!this.building.id || !this.building.search)
      ) {
        return { valid: false }
      }

      return {
        valid: true,
        value: {
          locationProjectRegion: this.region.search,
          locationProjectRegionId: this.region.id,
          locationProjectDistrict: this.district.search,
          locationProjectDistrictId: this.district.id,
          locationProject: this.project.search,
          locationProjectId: this.project.id,
          locationProjectBuilding: this.building.search,
          locationProjectBuildingId: this.building.id,
        },
      }
    },
    buildingStatus(): BuildingStatus {
      return this.$store.getters['valuationProcess/buildingStatus']
    },
  },
  methods: {
    resetDistrict() {
      this.district.id = undefined
      this.district.search = ''
    },
    resetProject() {
      this.project.id = undefined
      this.project.search = ''
    },
    resetBuilding() {
      this.building.id = undefined
      this.building.search = ''
    },
  },
  watch: {
    'region.id'(value: number | undefined) {
      this.resetBuilding()
      this.resetProject()
      this.resetDistrict()
      if (!value) {
        return
      }
      this.district.loading = true
      this.projectLocationService
        .getDistricts(value)
        .then(districts => {
          this.district.items = districts as IdValueObject[]
          const cachedId = getNestedValue(this.cachedLocationData, [
            'locationProjectDistrictId',
          ])
          if (cachedId && this.district.items.find(i => i.id === cachedId)) {
            this.district.id = cachedId
          }
        })
        .finally(() => (this.district.loading = false))
    },
    'district.id'(value: number | undefined) {
      this.resetBuilding()
      this.resetProject()
      if (!value) {
        return
      }
      this.project.loading = true
      this.projectLocationService
        .getProjects(value)
        .then(projects => {
          this.project.items = (projects as any[]).filter(
            x => this.buildingStatus === x.buildingStatus
          ) as IdValueObject[]
          const cachedId = getNestedValue(this.cachedLocationData, [
            'locationProjectId',
          ])
          if (cachedId && this.project.items.find(i => i.id === cachedId)) {
            this.project.id = cachedId
          }
        })
        .finally(() => (this.project.loading = false))
    },
    'project.id'(value: number | undefined) {
      this.resetBuilding()
      if (!value) {
        return
      }
      this.building.loading = true
      this.projectLocationService
        .getBuildings(value)
        .then(buildings => {
          this.building.items = buildings as IdValueObject[]
          const cachedId = getNestedValue(this.cachedLocationData, [
            'locationProjectBuildingId',
          ])
          if (cachedId && this.building.items.find(i => i.id === cachedId)) {
            this.building.id = cachedId
          }
        })
        .finally(() => (this.building.loading = false))
    },
  },
})
